import {
  NavClusterIconLink,
  useMediaQuery,
  WP_ICON_NAV_MOBILE,
  type NavClusterIconLinkProps,
} from '@wapharma/design-system';
import { getToken } from '../auth';
import { useConversationList } from '../hooks/useConversationList';
import { MessageTwotone } from '../icons/mxNavTwotone';
import { navTwotoneIcon } from '../lib/mxTwotoneIcon';

const MESSAGES_INBOX_EXCLUDE_ENTITY_TYPES = ['SupportTicket'] as const;

type MessagesNavLinkProps = {
  LinkComponent: NavClusterIconLinkProps['LinkComponent'];
  active?: boolean;
};

/** Header chip → dedicated Messages page (no flyout). */
export function MessagesNavLink({ LinkComponent, active = false }: MessagesNavLinkProps) {
  const narrow = useMediaQuery('(max-width: 47.99em)');
  const token = getToken();
  const list = useConversationList(
    token,
    {
      page: 1,
      limit: 1,
      status: 'OPEN',
      excludeEntityTypes: [...MESSAGES_INBOX_EXCLUDE_ENTITY_TYPES],
    },
    { live: true, pollMs: 20_000 },
  );
  const unread = list.unreadTotal > 0 ? list.unreadTotal : undefined;

  return (
    <NavClusterIconLink
      to="/messages"
      label="Messages"
      icon={navTwotoneIcon(MessageTwotone, narrow ? { size: WP_ICON_NAV_MOBILE.size } : undefined)}
      LinkComponent={LinkComponent}
      active={active}
      count={unread}
    />
  );
}
